import { StoresScreen } from '../features/stores/StoresScreen'

export function StoresPage() {
  return <StoresScreen />
}
